import { useParams } from "react-router-dom";
import { Page } from "@/components/layout/page";
import { ProjectTerminologyTab } from "@/components/project/terminology-tab";

export function ProjectTerminologyPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <Page
      title="Terminology"
      description="Domain vocabulary and consistency analysis"
    >
      <ProjectTerminologyTab projectId={id} />
    </Page>
  );
}
